<script lang="ts">
    import {KpPageContainer} from 'shared/layouts';
    import type {CssSize} from 'shared/ui-widgets/types';
    import {fly} from 'svelte/transition';
    import {exists} from 'shared/utils/custom-utils';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpLineLoadingIndicator from 'shared/components/kp-loading/KpLineLoadingIndicator.svelte';

    export let pageClass: string;
    export let loading = false;
    export let loaderType: 'circular' | 'line' = 'circular';
    export let gap: CssSize = '30px';
    export let isBootstrapContainer = true;
    export let containerClass = '';

    export let loadError = false;
    export let loadingLabel: string | null = null;
    export let loadErrorLabel: string | null = null;

    const pageFlyInParams = {y: 15, duration: 250};
</script>

<div class="kp-loadable-page-container {containerClass}" class:container={isBootstrapContainer}>
    {#if loading}
        <div class="loading-container" in:fly={pageFlyInParams}>
            {#if loaderType === 'circular'}
                <KpLoadingBlock/>
            {/if}

            {#if loaderType === 'line'}
                <KpLineLoadingIndicator/>
            {/if}

            {#if exists(loadingLabel)}
                {loadingLabel}
            {/if}
        </div>
    {/if}

    {#if loadError}
        <div class="loading-container load-error" in:fly={pageFlyInParams}>
            <IconedContent align="center" justify="center" orientation="vertical" icon="exclamation">
                {#if exists(loadErrorLabel)}
                    {loadErrorLabel}
                {/if}
            </IconedContent>
        </div>
    {/if}

    {#if !loading && !loadError}
        <KpPageContainer isBootstrapContainer={false}
                         additionalClasses={pageClass}
                         {gap}>

            <slot/>
        </KpPageContainer>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-loadable-page-container {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;

        .loading-container {
            width: 100%;
            margin-top: @spacing-xl;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: @spacing-ml;

            &.load-error {
                color: var(--danger-red);
            }
        }
    }

    :global {
        .kp-loadable-page-container {
            .panel {
                width: 100%;
            }
        }
    }
</style>